import { base } from "../../utils/request";
import { useState } from "react";

function Card({
  img,
  Category,
  description,
  Price,
  addPrice,
  removePrice, // إضافة هذا الـ prop
  subCategory, // إضافة هذا الـ prop
  UpTo // إضافة في حالة وجود
}) {
  const [quantity, setQuantity] = useState(1);
  const [isChecked, setIsChecked] = useState(false);

  // دالة التحديث عند التغيير
  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsChecked(checked);

    if (checked) {
      addPrice(Price * quantity);
    } else {
      removePrice(Price * quantity, subCategory);
      setQuantity(1);
    }
  };

  // دالة زيادة الكمية
  const increaseQuantity = () => {
    const newQuantity = quantity + 1;
    setQuantity(newQuantity);
    addPrice(Price);
  };

  // دالة تقليل الكمية
  const decreaseQuantity = () => {
    if (quantity > 1) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      removePrice(Price, subCategory);
    }
  };

  return (
    <section className="my-2 p-4 bg-[#fbfafa] md:w-[49%] w-full rounded-lg">
      <div className="text-center flex justify-center">
      <img className="h-28 w-48 object-contain mix-blend-darken" src={`${base}/${img}`} alt={Category} />

      </div>
      
      <section className="flex justify-between items-center my-4">
        <div>
          <h2 className="md:text-xl text-lg font-semibold">{Category}</h2>
          <p className="md:text-[16px] text-sm">
            {description}
            {UpTo && <span className="text-[#a47a24]"> ({UpTo})</span>}
          </p>
        </div>
        <input
          onChange={handleCheckboxChange}
          className="accent-[#a47a24] w-[24px] h-[24px] outline-none border-none cursor-pointer"
          type="checkbox"
          checked={isChecked}
        />
      </section>

      <section className="flex items-center justify-between">
        <h4 className="text-xl font-bold text-[#a47a24]">{Price} €</h4>
        {isChecked && (
          <div className="flex items-center gap-2">
            <button
              onClick={decreaseQuantity}
              className="bg-[#a47a24] text-white w-8 h-8 rounded-full flex items-center justify-center"
              disabled={quantity === 1}
            >
              -
            </button>
            <span>{quantity}</span>
            <button
              onClick={increaseQuantity}
              className="bg-[#a47a24] text-white w-8 h-8 rounded-full flex items-center justify-center"
            >
              +
            </button>
          </div>
        )}
      </section>
    </section>
  );
}

export default Card;